/**
 * Renders link "password requirements" with icon, click on it shows password requirement tips in popup.
 * Use options to adjust position of popup
 */
import TemplateView from '../../TemplateView'
import messageResource from '../../messageResource'
import PasswordHintTooltip from './PasswordHintTooltip'
import $ from 'jquery'

export default class PasswordHintLink extends TemplateView {

    constructor({
        passwordPolicy,
        my = "center top",
        at = "center bottom",
        top = 15,
        left = 0,
        $hintContainer = $("body")
    } = {}) {
        super();
        this.passwordPolicy = passwordPolicy;
        this.positionOptions = {};
        this.positionOptions.my = my || "center top";
        this.positionOptions.at = at || "center bottom";
        this.dialogOffsets = {};
        this.dialogOffsets.top = top || 15;
        this.dialogOffsets.left = left || 0;
        this.$hintContainer = $hintContainer;
    }

    templateHtml() {
        return `<div class="passwordHintLink">
                           <span class="passwordHintLink_title"><%-title%></span>
                           <div class="img"/>
                       </div>`;
    }

    templateModel() {
        return {
            title: messageResource.getMessage("profile.password_requirements")
        }
    }

    afterRender() {
        let hintTooltip = this.hintTooltip = new PasswordHintTooltip(this.passwordPolicy, {dialogOffsets: this.dialogOffsets})
            .init(this.$hintContainer);
        let $pointTo = this.$el.find(".img");
        let $txt = this.$el.find(".passwordHintLink_title");
        let positionOptions = this.positionOptions;
        this.$el.click(function() {
            hintTooltip.showAt($txt, positionOptions, $pointTo);
        });
    }

}



// WEBPACK FOOTER //
// ./web/js/util/passwords/PasswordHintLink.js